import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Clamp from 'react-multiline-clamp';
import { prepareSingleModuleResponseData } from './Standards.utils';
import useVideoLength from '../commons/UseVideoLength';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 94px;
  max-height: 94px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 58px;
  column-gap: 10px;
  height: 60px;
  padding: 18px 11px;
  border-radius: 6px;
  box-shadow: 0px 2px 5px 1px rgb(0 0 0 / 13%);
  -webkit-box-shadow: 0px 2px 5px 1px rgb(0 0 0 / 13%);
  -moz-box-shadow: 0px 2px 5px 1px rgb(0 0 0 / 13%);
`;

const Image = styled.div`
  width: 87px;
  height: 100%;
  min-width: 87px;
  max-height: 100%;
  img {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
  }
`;

const Information = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
`;

const InformationTopSection = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 3px;
`;

const Title = styled.span`
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 19px;
  margin-top: 3px;
`;

const Module = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #4fada6;
`;

const InformationBottomSection = styled.div`
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #919191;
  display: flex;
  column-gap: 8px;
  span {
    font-family: "Source Sans Pro";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
  }
`;

const SuggestedTrainingVideo = ({ itemData, module }) => {
  const navigate = useNavigate();

  const parsedData = prepareSingleModuleResponseData(itemData);
  const videoLength = useVideoLength(parsedData && parsedData.videoUrl);

  return (
    <Wrapper
      onClick={() => {
        navigate(`/learning/watch-video/${parsedData.id}`, {
          replace: true,
        });
      }}
    >
      <Container>
        <Image>
          <img src={parsedData.pictureUrl} />
        </Image>
        <Information>
          <InformationTopSection>
            <Module>{module}</Module>
            <Clamp withTooltip={true} lines={1}>
              <Title>{parsedData.label}</Title>
            </Clamp>
          </InformationTopSection>
          <InformationBottomSection>
            <span>{videoLength !== null ? Number(videoLength.toFixed(2)) : 0} min</span>
          </InformationBottomSection>
        </Information>
      </Container>
    </Wrapper>
  );
};

export default SuggestedTrainingVideo;
